import { Dropdown } from "./components/dropdown.js";
import MicroModal from "micromodal";
import { handleLinkClickToCloseModal } from "./components/modal.js";
import { contactForm } from "./components/contactForm.js";
import { header } from "./components/header.js";

document.addEventListener("DOMContentLoaded", () => {
    MicroModal.init({
        openClass: "show",
        disableScroll: true,
        awaitCloseAnimation: true,
    });
    handleLinkClickToCloseModal("modal-menu-mobile");

    header.init();

    const dropdownContainers = document.querySelectorAll(".dropdown__container");
    dropdownContainers.forEach((el) => new Dropdown(el));

    contactForm.init("form-contact");
});
